// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chart.js custom tooltip for word-break and wrapping */
.chartjs-tooltip {
  max-width: 150px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  background: rgba(0,0,0,0.7);
  color: #fff;
  padding: 8px;
  border-radius: 4px;
  pointer-events: none;
  z-index: 9999;
}
`, "",{"version":3,"sources":["webpack://./src/component/pages/reports/ReportDashBoard.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf","sourcesContent":["/* Chart.js custom tooltip for word-break and wrapping */\n.chartjs-tooltip {\n  max-width: 150px;\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  background: rgba(0,0,0,0.7);\n  color: #fff;\n  padding: 8px;\n  border-radius: 4px;\n  pointer-events: none;\n  z-index: 9999;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
